/**
 *   Created by wangyuelong on 2019/3/12
 */
export const pages = {
  FVCMT: 'FVCMT',
  VCMT: 'VCMT',
  CMT_MSG: 'CMT_MSG',
  CMT_PAGE: 'CMT_PAGE',
  article: 'article',
  CMT_DETAIL: 'CMT_DETAIL',
  GX_CMT_PAGE: 'GX_CMT_PAGE',
};

export const pageMap = {
  '/floatvideo/commentpage/': pages.FVCMT,
  '/video/commentpage/': pages.VCMT,
  '/commentMsg/_': pages.CMT_MSG,
  '/commentpage/': pages.CMT_PAGE,
  '/article': pages.article,
  '/comments/_': pages.CMT_DETAIL,
  '/circle/commentpage/_': pages.GX_CMT_PAGE,
};
